<template>
  <div class="page_container">
    <div>
        <woot-button
            color-scheme="success"
            class-names="button--fixed-right-top"
            icon="add-circle"
            @click="openAddPopup"
        >
        {{$t('CAMPAIGN.CAMPAIGN_FORMS.ADD_BTN')}}
        </woot-button>
    </div>
    <div class="content-box">
        <FormTable
            :cols="cols"
            :isLoading="uiFlags.isFetching"
            :records="campaignForms"
            :showEmptyResult="!uiFlags.isFetching && !campaignForms.length"
            @onDelete="openDeletePopup"
            @onEdit="openEditRoute"
        />
        <div>
            <table-footer
                :on-page-change="onPageChange"
                :current-page="Number(meta.current_page)"
                :total-count="meta.count"
                />
        </div>

        <woot-delete-modal
            :show.sync="showDeleteConfirmationPopup"
            :on-close="closeDeletePopup"
            :on-confirm="confirmDeletion"
            :title="$t('CAMPAIGN.DELETE.CONFIRM.TITLE')"
            :message="$t('CAMPAIGN.DELETE.CONFIRM.MESSAGE')"
            :confirm-text="$t('CAMPAIGN.DELETE.CONFIRM.YES')"
            :reject-text="$t('CAMPAIGN.DELETE.CONFIRM.NO')"
        />

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FormTable from "./FormTable.vue"
import helperMixin from 'shared/mixins/helperMixin';
import TableFooter from 'dashboard/components/widgets/TableFooter';

import alertMixin from 'shared/mixins/alertMixin';

export default {
    components:{
        FormTable,
        TableFooter,
    },
    mixins:[helperMixin,alertMixin],
    data(){
        return {
            showDeleteConfirmationPopup: false,
            selectedForm: null,
            cols: [
                { key: 'title', name: 'Title', visible: true, type: 'default' },
                { key: 'description', name: 'Description', visible: true, type: 'default' },
                { key: 'published', name: 'Published', visible: true, type: 'default' },
                { key: 'actions', name: 'Actions', visible: true, type: 'default' },
            ],
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'getCurrentUser',
            getAccount: 'accounts/getAccount',
            uiFlags: "campaigns/getUIFlagsForms",
            meta: "campaigns/getFormMeta",
            campaignForms: "campaigns/getCampaignForms",
        }),
        currentAccount(){
            return this.getAccount(this.currentUser.account_id);
        },
    },
    watch: {
        currentAccount: {
            handler(newVal) {
                if (newVal?.features && !newVal.features.forms) {
                    // redirect to home if not allowd form feature
                    this.$router.push("/");
                }
            },
            immediate: true
        }
    },
    activated() {
    // When revisiting the route (with <keep-alive>)
        this.fetchRecords({
            page: 1,
        });
    },
    deactivated() {
        // const endDate = new Date(); // Current date
        // const startDate = new Date();
        // startDate.setMonth(startDate.getMonth() - 1); // One month ago
        // this.dateRange = [startDate,endDate];
    },
    methods:{
        async fetchRecords(newQuery={}){
            try {
                const defautQuery = {
                    page: this.meta.current_page,
                    page_size:  this.meta.page_size,
                    ...newQuery,
                }
                this.$store.dispatch("campaigns/fetchCampaignForms",this.cleanObject(defautQuery));
            } catch (error) {
                console.log(error);
            }
        },
        onPageChange(page){
            this.fetchRecords({page,})
        },
        openDeletePopup(response) {
            console.log(response);
            this.showDeleteConfirmationPopup = true;
            this.selectedForm = response;
        },
        closeDeletePopup() {
            this.showDeleteConfirmationPopup = false;
        },
        async confirmDeletion() {
            this.closeDeletePopup();
            try {
                await this.$store.dispatch('campaigns/deleteCampaignForm', {form_id:this.selectedForm.id});
                 this.showAlert(this.$t('CAMPAIGN.CAMPAIGN_FORMS.DELETE.ACTIONS.SUCCESS'));
                this.selectedForm = null;
            } catch (error) {
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            }
        },
        openAddPopup(){
            this.$router.push(`/app/accounts/${this.currentUser.account_id}/campaigns/forms/add`)
        },
        openEditRoute(response){
            // this.$router.push(`/app/accounts/${this.currentUser.account_id}/campaigns/forms/edit/${response.id}`)
            this.$router.push({
                name:"campaign_form_edit",
                params:{
                    campaign_form_id:response.id,
                    account_id:this.currentUser.account_id,
                }
            })
        },
    },
}
</script>

<style>

</style>